const PersianOrnament = ({ className = "" }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>
    <path d="M2 50C2 24 24 2 50 2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2 34C2 16 16 2 34 2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2 18C2 9 9 2 18 2" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="50" cy="2" r="2.5" fill="currentColor" />
    <circle cx="2" cy="50" r="2.5" fill="currentColor" />
    <path d="M14 14L20 20M14 20L20 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default PersianOrnament;
